<div class="card card-custom section-margin-bottom-60">
  <ng-container *ngIf="viewModel$|async as viewModel">
    <div class="card-header criterion-header">
      <div class="card-title">
        <div class="card-label">
          <span >Comparables</span>
        </div>
      </div>
    </div>

    <div class="card-body criterion-body">
      <div class="col-md-12 mat-table-wrapper">
        <table mat-table class="lmat-elevation-z8" [dataSource]="viewModel.dataSource">
          <ng-container matColumnDef="building">
            <th mat-header-cell *matHeaderCellDef>
              Building
            </th>
            <td mat-cell *matCellDef="let item">
              {{ item.buildingName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef>
              Size ({{ viewModel.unit }})
            </th>
            <td mat-cell *matCellDef="let item">
              {{ item.size | mask:'separator.2':{thousandSeparator:','} }}
            </td>
          </ng-container>

          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef>
              Total Price ({{ viewModel.currency }})
            </th>
            <td mat-cell *matCellDef="let item">
              {{ item.price  | mask:'separator.2':{thousandSeparator:','} }}
            </td>
          </ng-container>

          <ng-container matColumnDef="bua">
            <th mat-header-cell *matHeaderCellDef>
              Price on BUA ({{ viewModel.currency }}/{{ viewModel.unit }})
            </th>
            <td mat-cell *matCellDef="let item">
              {{ item.bua  | mask:'separator.2':{thousandSeparator:','} }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
              Date
            </th>
            <td mat-cell *matCellDef="let item">
              {{ item.date | date:'dd MMM yyyy' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="evidence">
            <th mat-header-cell *matHeaderCellDef>
              Evidence Type
            </th>
            <td mat-cell *matCellDef="let item">
              {{ item.evidenceType }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns; let i = index" [ngClass]="{'colored-row': i%2}"></tr>
        </table>
      </div>
    </div>
  </ng-container>
</div>